<template>
  <custom-popup v-model="dialog" :cons="cons" :hide-confirm="editHour" hide-close max-width="1024" persistent>
    <v-card class="pa-4" flat>
      <transition mode="out-in" name="slide-x-transition">
        <div v-if="!editHour" key="items">
          <v-tabs v-model="computedTabs" class="mb-4">
            <v-tab v-for="(item, i) in dates" :key="i">
              <div v-if="item.text" v-html="item.text.replace(' ', '<br>')"/>
            </v-tab>
          </v-tabs>
          <v-divider/>
          <v-tabs-items v-model="computedTabs">
            <v-card class="d-flex pa-2 flex-wrap dialog-content">
              <v-card-title class="col-12 justify-end">
                <v-btn color="success" outlined small @click="[pIndex = null, editHour = true]">
                  <v-icon>mdi-plus</v-icon>
                  افزودن نوبت جدید
                </v-btn>
              </v-card-title>

              <template v-if="rerender">
                <v-btn v-for="(item, i) in computedDates[tabs].times" :key="i" class="rounded-lg ma-2" outlined
                       small>
                  <span class="font-size-base">{{ item.time.slice(0, 5) }}</span>

                  <!--                <v-btn color="red" icon>-->
                  <!--                  <v-icon>mdi-close</v-icon>-->
                  <!--                </v-btn>-->

                  <v-btn icon small @click.stop="[pIndex = i, editHour = true]">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  <v-btn :loading="deletingHour === i" color="red" icon small @click.stop="deleteHour(item.id, i)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-btn>
              </template>
            </v-card>
          </v-tabs-items>
        </div>

        <div v-else key="edit">
          <edit-appointment-hour v-model="computedHour" :hours="computedDates[tabs].times"
                                 @close="[editHour = false, pIndex = null]" @save="saveAppointment"/>
        </div>
      </transition>
    </v-card>
  </custom-popup>
</template>

<script>
import EditAppointmentHour from "@/view/pages/otherQrTypes/appointment/cm/editAppointmentHour.vue";
import {mapState} from "vuex";

export default {
  name: "editAppointmentDates",

  components: {EditAppointmentHour},

  props: {
    value: Boolean,
    tabs: Number,
    dates: Array,
    loading: Boolean,
    categoryId: Number
  },

  data() {
    return {
      editHour: false,
      pIndex: null,
      cons: {
        title: 'ویرایش نوبت‌ها',
        buttons: [
          {type: 'submit', handler: this.submitAppointments}
        ]
      },
      deletingHour: null,
      rerender: true,
    }
  },

  computed: {
    ...mapState('localstorage', ['createQrID']),
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    computedTabs: {
      get() {
        return this.tabs
      },
      set(val) {
        this.$emit('update:tabs', val)
      }
    },
    computedDates: {
      get() {
        return this.dates
      },
      set(val) {
        this.$emit('update:dates', val)
      }
    },
    computedHour: {
      get() {
        return this.pIndex != null && this.computedDates[this.tabs].times[this.pIndex]
      },
      set(val) {
        // prevent/remove from add/edit duplicates (val.time)
        let times = JSON.parse(JSON.stringify(this.computedDates[this.tabs].times))
        this.pIndex != null ? times[this.pIndex] = val : times.push(val)
        times = new Map(times.map(item => [item.time, item]))

        this.computedDates[this.tabs].times = []
        this.rerender = false
        this.$nextTick(() => {
          this.computedDates[this.tabs].times = [...times.values()]
          this.rerender = true
          this.$forceUpdate()
        })
      }
    },
    computedLoading: {
      get() {
        return this.loading
      },
      set(val) {
        this.$emit('update:loading', val)
      }
    }
  },

  methods: {
    saveAppointment(obj) {
      if (this.pIndex == null)
        this.computedDates[this.tabs].times.push(obj)

      this.pIndex = null
      this.editHour = false
      this.$forceUpdate()
    },
    submitAppointments() {
      this.computedLoading = true

      let dates = this.computedDates.map(item => {
        return {
          ...item,
          ...(this.categoryId && {res_category_id: this.categoryId}),
          qr_id: this.createQrID || 1
        }
      })

      this.$api.post('/v1/testQr/reservation', {
        data: JSON.stringify(dates)
      })
        .then(({data}) => {
          try {
            this.computedDates = this.computedDates.map(item => {
              return {
                ...item,
                times: item.times.map(t => {
                  return {
                    ...t,
                    id: t.id || data.data.find(d => d.reserve_time === item.value + ' ' + t.time)?.id
                  }
                })
              }
            })
          } catch (e) {
            console.log(e)
          }
        })
        .catch(({response}) => console.log('failed to store appointments: ', response))
        .finally(() => this.computedLoading = false)
    },
    async deleteHour(id, index) {
      if (await this.$modal.yesNo('تایید حذف نوبت ؟')) {
        this.deletingHour = index

        if (id != null)
          this.$api.delete(`/v1/testQr/reservation/${id}`)
            .then(({data}) => {
              this.$toast.clear()
              this.$toast.success(data.message)
              this.computedDates[this.tabs].times.splice(index, 1)
            })
            .finally(() => this.deletingHour = null)
        else {
          this.computedDates[this.tabs].times.splice(index, 1);
          this.deletingHour = null
        }
      }
    }
  }
}
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}
</style>